import { __ } from 'i18n/index';

export default class Distance {

	constructor(distanceInMeters) {
		this.distance = distanceInMeters;
	}

	get miles() {
		return this.distance * 0.000621371;
	}

	get meters() {
		return this.distance;
	}

	get kilometers() {
		return this.distance / 1000;
	}

	static createFromMiles(miles) {
		return new Distance(1609.34 * miles);
	}

	static createFromMeters(meters) {
		return new Distance(meters);
	}

	static createFromKilometers(kilometers) {
		return new Distance(kilometers * 1000);
	}

	// "~2,100 km": rounded to the nearest hundred, or ten under a hundred.
	approximateLabel(useMiles) {
		const amount = useMiles ? this.miles : this.kilometers;
		const unit = useMiles ? 'mi' : 'km';
		if(amount < 10) {
			return `<10 ${unit}`;
		}
		const step = amount < 100 ? 10 : 100;
		const rounded = Math.round(amount / step) * step;
		return `~${rounded.toLocaleString('en-US')} ${unit}`;
	}

	static getAllDescriptions() {
		return new Map(Distance.distanceDescriptions);
	}

	getDistanceSeverity() {
		const compare = this.distance / 1000;
		const breakPoints = DistanceVariables.proximities;

		if(compare <= breakPoints.NEIGHBORS) {
			return 1;
		}
		if(compare <= breakPoints.CLOSE) {
			return 2;
		}
		if(compare <= breakPoints.MODERATE) {
			return 3;
		}
		if(compare <= breakPoints.DISTANT) {
			return 4;
		}
		return 5;
	}

	getDistanceColor() {
		const severity = this.getDistanceSeverity();
		return Distance.distanceColors[severity];
	}

	static getDistanceSeverityClass(severity) {
		return `distance_severity distance_severity_${severity}`;
	}

	static getDistanceDescriptionById(distanceId) {
		return Distance.distanceDescriptions.get(Number.parseInt(distanceId));
	}
}

Distance.distanceDescriptions = new Map([
	[1, __("Short Distance")],
	[2, __("Close / Regional")],
	[3, __("Moderate / Nearby Region")],
	[4, __("Pretty Far Away")],
	[5, __("Very Far Away")]
]);

Distance.distanceColors = {
	1: "#00FFE7",
	2: "#EFFF00",
	3: "#FFB800",
	4: "#FF6B00",
	5: "red",
};